import src from "IMAGE";
export default { src, width: 71, height: 231, blurWidth: 2, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAICAYAAADTLS5CAAAARElEQVR42k3GuwnAIBRA0QsOpNPpBAGbLBDSZrKgrYifRlBfaXHgcBvjvdYX3blarc0spaYYLJjiSIQgfj54xUODUiBtda0eWRqMsusAAAAASUVORK5CYII="};
